export default __webpack_public_path__ + "static/blue_sky_desk-3dd9eaa45e15475f7b4c339dc81e09d5.mp4";